// assets/infinite-scroll.js
(() => {
  const SELECTORS = {
    // Prestige typically uses <product-list class="product-list"> with children <product-card>
    list: 'product-list.product-list, product-list, .product-list, #main product-list',
    loadMoreBtn: '[data-load-more][data-next-url]',
  };

  const getList = (root = document) => root.querySelector(SELECTORS.list);
  const getLoadMoreBtn = (root = document) => root.querySelector(SELECTORS.loadMoreBtn);

  // --- Reveal-on-scroll support (Prestige uses reveal-on-scroll="true") ---
  const revealObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        const el = entry.target;
        // Prestige-style: flip attribute off to let CSS show it
        el.setAttribute('reveal-on-scroll', 'false');
        revealObserver.unobserve(el);
      }
    },
    { root: null, rootMargin: '200px 0px', threshold: 0.01 }
  );

  const initReveal = (root) => {
    if (!root) return;

    // include root itself if it matches
    const targets = [];
    if (root.matches?.('[reveal-on-scroll="true"]')) targets.push(root);

    root.querySelectorAll?.('[reveal-on-scroll="true"]').forEach((el) => targets.push(el));

    targets.forEach((el) => revealObserver.observe(el));
  };

  const fetchHTML = async (url) => {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);
    return res.text();
  };

  const appendNextPage = async () => {
    const list = getList(document);
    const btn = getLoadMoreBtn(document);
    if (!list || !btn) return;

    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'LOADING…';

    try {
      const html = await fetchHTML(nextUrl);
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newList = getList(doc);
      if (!newList) throw new Error('No product list found on next page');

      // Append children (product cards)
      const nodes = Array.from(newList.children);
      nodes.forEach((node) => list.appendChild(node));

      // IMPORTANT: initialise reveal-on-scroll for appended cards
      nodes.forEach((node) => initReveal(node));

      // Update next URL or remove button
      const newBtn = getLoadMoreBtn(doc);
      if (newBtn?.dataset?.nextUrl) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        btn.disabled = false;
        btn.textContent = originalText;
      } else {
        btn.remove();
      }
    } catch (e) {
      console.error(e);
      btn.disabled = false;
      btn.textContent = originalText;
    }
  };

  const setupInfinite = () => {
    const btn = getLoadMoreBtn(document);
    if (!btn) return;

    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) appendNextPage();
      },
      { root: null, rootMargin: '800px 0px', threshold: 0 }
    );

    io.observe(btn);
  };

  window.addEventListener('load', () => {
    // initialise reveal for existing cards too (safe)
    initReveal(document);
    setupInfinite();
  });
})();
